module.exports = __webpack_public_path__ + "img/stage_cn.277589f.jpg";